import { IS_AUTOLOGIN } from "@web/components/Auth/LoginForm"
import { getCookie, deleteCookie } from "cookies-next"
import React from "react"
import { useRedirectAfterLogin } from "./useRedirectAfterLogin"
import { useWindowMessageContext } from "@web/context/WindowMessageContext"
import { useExtensionCredentialsSync } from "./useCredentials"

interface UseAfterLoginHooksArgs {
  redirectTo?: string | null
}

/**
 * Hooks to run on a page after logging in.
 * Pages that a user gets redirected to after logging in should use this hook.
 */
export const useAfterLoginHooks = ({ redirectTo }: UseAfterLoginHooksArgs = {}) => {
  const [isAutoLogin, setIsAutoLogin] = React.useState(false)
  const { beganExtensionAuth } = useWindowMessageContext()

  // copy autologin cookie to session storage
  React.useEffect(() => {
    const autoLoginCookie = getCookie("autoLogin")
    const isAutoLogin = autoLoginCookie === "complete"

    if (isAutoLogin) {
      deleteCookie("autoLogin")
      sessionStorage.setItem(IS_AUTOLOGIN, "true")
    }

    setIsAutoLogin(isAutoLogin)
  }, [])

  useExtensionCredentialsSync()

  const { isRedirecting } = useRedirectAfterLogin({ redirectTo, isAutoLogin, skip: beganExtensionAuth && isAutoLogin })

  return { isRedirecting }
}
